import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-carrier-rates',
  templateUrl: './new-carrier-rates.component.html',
  styleUrls: ['./new-carrier-rates.component.scss']
})
export class NewCarrierRatesComponent implements OnInit {
  @Input() newCarrierForm;
  @Input() set additionalOptions(options) {
    this.groupAdditionalOptions(options);
  }
  @Input() submitted;

  @Input() coverageOptions;

  groupedAdditionalOptions;
  hasPetsAttribute = false;

  ngOnInit(): void {
    this.hasPetsAttribute = this.coverageOptions?.has_pets;
  }

  groupAdditionalOptions(options) {
    this.groupedAdditionalOptions = {
      coverage: {
        options: options.filter(f => (f.category === 'coverage' && f.requirement === 'required')
                                     || (f.category === 'limit' && f.requirement === 'required'))
      },
      additional_coverage: {
        options: options.filter(f => (f.category === 'coverage' && f.requirement !== 'required')
                                    || (f.category === 'option' && f.requirement !== 'required'))
      },
      deductible: {
        options: options.filter(f => f.category === 'deductible')
      }
    };
  }
}
